import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component';

import { ShippingStepsComponent } from './shipping-steps/shipping-steps.component';
import { ShippingComponent } from './shipping.component';

const routes: Routes = [
  {
    path: '', component: ShippingComponent,
    children: [
      { path: '', component: ShippingStepsComponent },
      { path: 'order-confirmation', redirectTo: 'order-confirmation/0' },
      { path: 'order-confirmation/:deliveryId', component: OrderConfirmationComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShippingRoutingModule { }
